"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AvatarProps", {
  enumerable: true,
  get: function get() {
    return _types.AvatarProps;
  }
});
Object.defineProperty(exports, "AvatarRef", {
  enumerable: true,
  get: function get() {
    return _types.AvatarRef;
  }
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _AvatarContainer = _interopRequireDefault(require("./AvatarContainer"));

var _AvatarContent = _interopRequireDefault(require("./AvatarContent"));

var _AvatarIndicator = _interopRequireDefault(require("./AvatarIndicator"));

var _commonUIColors = require("../../utils/commonUIColors");

var _constants = require("./constants");

var _types = require("./types");

var _schema = _interopRequireDefault(require("./schema"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function Avatar(props, ref) {
  var ariaLabel = props['aria-label'],
      email = props.email,
      entityType = props.entityType,
      kind = props.kind,
      name = props.name,
      size = props.size,
      indicatorColor = props.indicatorColor;
  var translate = (0, _useTranslations.default)();
  return _react.default.createElement(_AvatarContainer.default, {
    ref: ref,
    kind: kind,
    size: size
  }, _react.default.createElement("span", {
    "aria-label": translate(ariaLabel, 'avatar.aria.label', {
      descriptor: name || email || entityType
    }),
    role: "img"
  }, _react.default.createElement(_AvatarContent.default, props)), indicatorColor && indicatorColor in _commonUIColors.commonUIColors && _react.default.createElement(_AvatarIndicator.default, {
    size: size,
    color: indicatorColor
  }));
}

var AvatarWithRef = (0, _react.forwardRef)(Avatar);
AvatarWithRef.propTypes = _schema.default.propTypes;
AvatarWithRef.defaultProps = {
  email: undefined,
  entityType: _constants.entityTypes.person,
  kind: _constants.kinds.primary,
  name: undefined,
  size: _constants.sizes.medium,
  indicatorColor: undefined
};
var _default = AvatarWithRef;
exports.default = _default;